import { localized, msg } from "@lit/localize";
import { LitElement, css, html } from "lit";
import { customElement } from "lit/decorators.js";

@localized()
@customElement("error-element")
export class ErrorElement extends LitElement {
    static styles = css`
      .error {
        text-align: center;
      }
    `;

    render() {
        return html`
          <div>
              <div class="course-list">
                <div class="error">
                  <div style="font-size: 80px">🚧</div>
                  ${msg("Something went wrong. Please try again later.")}
                </div>
              </div>
          </div>
        `;
    }
}
